<template>
    <span
        @mouseup.stop
        @keyup.stop
        @keydown.stop
        @input.stop
        :data-entity="localEntity"
        :data-role="localRole"

        ref="merge_tag"
        contenteditable="false"
        class="bracket"
        :class="localEntity && bracketGroup(localEntity)"
    >
      <span>{</span>
      <span @click.stop.prevent="openEntityList">
        <input
            v-show="localEntity"
            :style="inputStyle('entity')"
            class="bracket-label"
            disabled
            ref="entityLabel"
            :value="localEntity"
        />
      </span>
      <span @click.stop.prevent="openRoleList">
        <input
          v-show="localRole"
          class="role-input"
          disabled
          :style="inputStyle('role')"
          ref="roleLabel"
          :value="`:${localRole}`"
        />
      </span>
      <span>}</span>
      <or-popover ref="entitiesList" trigger="merge_tag" openOn="">
        <div class="popover-list__item"
            v-for="entity in allEntities"
            :key="entity.id"
            @click="selectEntity(entity)"
        >
          {{entity.name}}
        </div>
      </or-popover>
      <or-popover ref="rolesList" trigger="merge_tag" openOn="">
        <div class="popover-list">
             <div class="popover-list__item"
                v-for="role in listOfRoles"
                :key="role.value"
                @click="selectRole(role.value)"
            >{{role.label}}</div>
        </div>
      </or-popover>
    </span>
</template>

<script>
import * as _ from 'lodash'

const INPUT_MINIMAL_WIDTH = 5
// const CURLY_WRAPPERS_WIDTH = 0
const POPOVER_MARGIN = 0

export default {

  computed: {
    // ...mapState('knowledgebase',['allEntities']),

    localEntity: {
      get () {
        return this.innerValue.entity
      },
      set (value) {
        this.innerValue = {
          ...this.innerValue,
          entity: value
        }
      }
    },
    localRole: {
      get () {
        return this.innerValue.role
      },
      set (value) {
        this.innerValue = {
          ...this.innerValue,
          role: value
        }
      }
    },

    filteredDataOuts () {
      let filteredData = _.flatMap(this.dataOuts, titled => _.map(titled.variables, dataOut => ({ ...dataOut, title: titled.title })))
      if (this.innerValue) {
        filteredData = _.filter(filteredData, dataOut => _.startsWith(dataOut.variableName, this.innerValue))
      }
      return _.map(filteredData, (value, index) => ({ ...value, index }))
    },

    innerValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },

    localMaxWidth: {
      get () {
        return this.$props.maxWidth
      },
      set (value) {
        this.$emit('update:maxWidth', value)
      }
    }
  },

  props: {
    value: Object,
    pattern: {
      type: Array,
      default: () => ([])
    },
    allEntities: {
      type: Array,
      default: () => ([])
    },
    textPosition: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default () {
        return []
      }
    },
    stepId: {
      type: String,
      default: ''
    },
    mergeFields: {
      type: Array,
      default () {
        return []
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      listOfRoles: [],
      editing: false,
      selectedTagIndex: null
    }
  },

  methods: {

    inputStyle (type) {
      const valueWidth = this.getValueWidth(type)
      return {
        width: `${valueWidth}px`
      }
    },
    openEntityList () {
      if (this.readonly) return
      this.$refs.entitiesList.open()
    },
    openRoleList () {
      if (this.readonly) return
      this.$refs.rolesList.open()
    },

    bracketGroup (entity) {
      const groupList = [
        'green',
        'red',
        'yellow',
        'lightcoral',
        'yellowgreen',
        'hotpink',
        'sandybrown',
        'chocolate'
      ]

      const group = [...entity].reduce((count, el) => (count + el.charCodeAt()), 0) % groupList.length
      return groupList[group]
    },
    selectEntity (entity) {
      this.localEntity = entity.name
      this.localRole = null
      this.$refs.entitiesList.close()
      if (!_.isEmpty(entity.roles)) {
        this.listOfRoles = _.chain(entity.roles).reject(el => console.log(_
          .chain(this.pattern)
          .filter(['path.entity', entity.name])
          .map('path.role')
          .includes(el)
          .value()) || _
          .chain(this.pattern)
          .filter(['path.entity', entity.name])
          .map('path.role')
          .includes(el)
          .value()
        )
          .map((value) => ({
            label: `${entity.name}:${value}`,
            value
          })).value()
        this.$refs.rolesList.open()
      }
      this.$nextTick(() => {
        this.finishEditing()
      })
    },

    selectRole (role) {
      this.localRole = role
      this.$refs.rolesList.close()
      this.$nextTick(() => {
        this.finishEditing()
      })
    },

    handleMouseDown () {
      this.$emit('mousedown')
    },

    setMaxWidth (maxWidth) {
      this.localMaxWidth = maxWidth
    },

    scrollSelectedItemToVisibility () {
      const wrapper = this.$refs.dataOutsWrapper.$el
      const items = _.reduce(wrapper.getElementsByClassName('list-item'), (memo, node) => {
        if (!memo.first && node && node.offsetTop >= wrapper.scrollTop) {
          memo.first = node
        }

        if (node && node.offsetTop + node.clientHeight <= wrapper.scrollTop + wrapper.clientHeight) {
          memo.last = node
        }

        if (node && node.classList.contains('active')) {
          memo.selected = node
        }

        return memo
      }, {
        first: null,
        last: null,
        selected: null
      })

      if (items.selected && items.first && items.selected.offsetTop < items.first.offsetTop) {
        wrapper.scrollTop = items.selected.offsetTop
      } else if (items.selected && items.last && items.selected.offsetTop > items.last.offsetTop) {
        wrapper.scrollTop = items.selected.offsetTop - wrapper.clientHeight + items.selected.clientHeight
      }
    },

    focus () {
      this.openEntityList()
    },

    getDataOutClass (dataOut, index) {
      return `${dataOut.subObject ? 'sub-object' : 'root'} ${index === this.selectedTagIndex
                    ? 'active'
                    : ''}`
    },

    getValueWidth (type) {
      const tempSpan = document.createElement('span')
      tempSpan.classList.add('temp-ruler-span')
      tempSpan.innerHTML = `{${this.innerValue[type]}}`
      document.body.appendChild(tempSpan)
      const width = tempSpan.offsetWidth
      tempSpan.remove()
      return width || INPUT_MINIMAL_WIDTH
    },

    handleFocus () {
      this.startEditing()
    },

    handleBlur (event) {
      const targetName = _.get(event, 'relatedTarget.name', '')
      if (targetName === 'search-data-out') {
        return
      }
      this.finishEditing()
    },

    handleMergeTagMouseDown (dataOut) {
      this.setPath(dataOut.variableName)
      this.$nextTick(() => {
        this.finishEditing()
      })
    },

    handleMouseup () {
      this.focus()
    },

    handleKeyUp (event) {
      if (this.keyPressed(event, 'Enter')) {
        this.handleEnter(event)
      }
    },

    handleKeyDown (event) {
      if (this.keyPressed(event, 'Enter')) {
        event.preventDefault()
      } else if (this.keyPressed(event, 'ArrowDown')) {
        this.handleArrowDown(event)
      } else if (this.keyPressed(event, 'ArrowUp')) {
        this.handleArrowUp(event)
      } else if (this.keyPressed(event, 'Space')) {
        this.handleSpace(event)
      }
    },

    handleEnter (event) {
      if (this.selectedTagIndex === null) {
        this.finishEditing()
      } else {
        this.setPath(this.filteredDataOuts[this.selectedTagIndex].variableName)
        this.$nextTick(() => {
          this.finishEditing()
        })
      }
      event.preventDefault()
      event.stopPropagation()
    },

    handleArrowDown (event) {
      if (this.selectedTagIndex === null) {
        this.selectedTagIndex = 0
      } else if (this.selectedTagIndex < this.filteredDataOuts.length - 1) {
        this.selectedTagIndex += 1
      }
      this.$nextTick(() => {
        this.scrollSelectedItemToVisibility()
      })
      event.preventDefault()
    },

    handleArrowUp (event) {
      if (this.selectedTagIndex === 0) {
        this.selectedTagIndex = null
      } else if (this.selectedTagIndex > 0) {
        this.selectedTagIndex -= 1
      }
      this.$nextTick(() => {
        this.scrollSelectedItemToVisibility()
      })
      event.preventDefault()
    },

    handleSpace (event) {
      this.finishEditing()
      event.preventDefault()
    },

    keyPressed (event, key) {
      const keyCodes = {
        Enter: 13,
        ArrowUp: 38,
        ArrowDown: 40,
        Space: 32
      }

      return event.key === key || event.keyCode === keyCodes[key]
    },

    startEditing () {
      this.$emit('start-editing')
      this.editing = true

      this.$nextTick(() => {
        const maxWidth = Math.floor(window.innerHeight / 2 - POPOVER_MARGIN) // eslint-disable-line no-unused-vars
        // this.$refs.dataOutsWrapper.$el.style.maxHeight = `${maxWidth}px`;
        // this.$refs.dataOutPopover.open();
      })
    },

    /**
             * signal editable that merge tag editing is ended
             * and possibly set caret right after the tag
             */
    finishEditing () {
      // if (this.$refs.dataOutPopover) {
      // this.$refs.dataOutPopover.close();
      // }
      // this.$refs.input.blur();
      this.editing = false

      this.$emit('finish-editing', { textPosition: this.textPosition })
    },

    setPath (path) {
      this.innerValue = path
    }
  },
  mounted () {
    if (this.localRole) {
      this.listOfRoles = _
        .chain(this.allEntities)
        .find(['name', this.localEntity])
        .get('roles')
        .map((value) => ({
          label: `${this.localEntity}:${value}`,
          value
        }))
        .value()
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    // @import '../../../scss/mixins';
    // @import '../../../scss/colors';

    .merge-tag {
        display: inline-block;
        // color: $active;
        position: relative;
        white-space: nowrap;
        -moz-user-select: text !important;
        >span{
            -moz-user-select: text !important;
        }
    }

    .or-popover.data-outs {
        padding: 0;
    }

    .bracket{
        color: #333;
        font-size: 14px;

        .bracket-label{
            border: none;
            color: white;
            word-break: normal;
            border-radius: 3px;
            margin: 0 3px;
            padding: 2px 4px;
            font-size: 14px;
            font-weight: normal;
            & + input{
                border: none;
            }
        }

        .role-input{
            background-color: white;
            border: none;
        }

        &.green{
            color: darkgreen;
            .bracket-label{
                color: white;
                background-color: darkgreen;
            }
        }

        &.red{
            color: darkred;
            .bracket-label{
                color: white;
                background-color: darkred;
            }
        }

        &.yellow{
            color: darkorange;
            .bracket-label{
                color: white;
                background-color: darkorange;
            }
        }

        &.lightcoral{
            color: lightcoral;
            .bracket-label{
                color: white;
                background-color: lightcoral;
            }
        }

        &.yellowgreen{
            color: yellowgreen;
            .bracket-label{
                color: white;
                background-color: yellowgreen;
            }
        }

        &.hotpink{
            color: hotpink;
            .bracket-label{
                color: white;
                background-color: hotpink;
            }
        }

        &.sandybrown{
            color: sandybrown;
            .bracket-label{
                color: white;
                background-color: sandybrown;
            }
        }

        &.chocolate{
            color: chocolate;
            .bracket-label{
                color: white;
                background-color: chocolate;
            }
        }
    }

</style>

<style lang="scss" rel="stylesheet/scss">
    // @import '../../../scss/mixins';

     .popover-list{
        &__item{
            font-size: 12px;
            padding: 8px 6px;
        }
    }

    span.temp-ruler-span {
        border: none;
        outline: none;
        display: inline;
        margin: 0;
        padding: 0;
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        background: transparent;

        // @include normal-font;
    }
</style>
